import styled from '@emotion/styled';

export const SwiperCardsContainer = styled.div<{ alignCenter?: boolean }>`
  .swiper-wrapper {
    justify-content: ${({ alignCenter }) => (alignCenter ? 'center' : 'inherit')};
  }
`;

